import { Paper } from '@mui/material';
import React from 'react';

const PaperSelect = (props: ExpectedAny) => {
  return <Paper elevation={8} {...props} />;
};

export default PaperSelect;
